import { AssessmentCompleteFailed } from './AssessmentCompleteFailed';
import { AssessmentSubmitting } from './AssessmentSubmitting';

interface IAssessmentCompleteFallbackUIProps {
  evaluationId: string;
  hasMissedFeatures: boolean;
  isLoading: boolean;
  onRestart: () => void;
  onRetry: () => void;
}

/**
 * -----------------------------------------------------------------------------
 * This is rendered when the user is submitting the assessment or when they
 * have a failed to submit the assessment.
 */
export function AssessmentCompleteFallbackUI({
  evaluationId,
  hasMissedFeatures,
  isLoading,
  onRestart,
  onRetry,
}: IAssessmentCompleteFallbackUIProps) {
  if (isLoading) {
    return <AssessmentSubmitting evaluationId={evaluationId} />;
  }

  return (
    <AssessmentCompleteFailed
      evaluationId={evaluationId}
      hasMissedFeatures={hasMissedFeatures}
      onRestart={onRestart}
      onRetry={onRetry}
    />
  );
}
